class ExpressSelectedDialogController {
    constructor(expressService) {
        this.expressService = expressService;
    }
}

ExpressSelectedDialogController.$inject = ['ExpressService'];

const expressSelectedDialogControllerComponentDefinition = {
    template: require('./express-selected-dialog.component.html').trim(),
    controller: ExpressSelectedDialogController,
};

module.exports = {
    ExpressSelectedDialogController,
    expressSelectedDialogControllerComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/express/dialog/express-selected-dialog.component.js